const formatCurrency = (value) => {
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(value || 0));
};

export const formatCurrencyWithSymbol = (value) => {
  return `₹${formatCurrency(value)}`;
};

export default formatCurrency;
